import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Card, Typography } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import "./ApplicationRejected.css";
import _consumerService from "../../../modules/consumerService";
import _commonService from "../../../modules/commonService";

const { Title, Text } = Typography;

const ApplicationRejectedAlert = () => {
      const [loading, setLoading] = useState(false);
       const [applicantDetails, setApplicantDetails] = useState({});
        const history = useHistory();
         const location = useLocation();
          let data = location.state;
           let applicationObjId = "";
         
           if (data && data.applicationData && data.applicationData.Id) {
             applicationObjId = data.applicationData.Id;
           }
           const [applnObjId] = useState(applicationObjId ? applicationObjId : localStorage.getItem("ApplicationObjId"));
       const getApplicantDetailsByID = async (applnObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getConsumerInformationByConsumerId(applnObjId);
      console.log(res, "res")
      if (res.data) {
        let resObj = res?.data;
        setApplicantDetails(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
 useEffect(() => {  
      getApplicantDetailsByID(applnObjId);    
  }, []);
  return (
    <Card className="application-rejected-card" bordered={false}>
      <div className="rejected-header">
        <CloseCircleFilled className="rejected-icon" />
        <Title level={4} className="rejected-title">
          Application Rejected
        </Title>
      </div>

      <Text className="rejected-subtext">
        Unfortunately, your application was rejected on { _commonService.getCurrentMonthAndYear(applicantDetails?.UpdatedDate)}.
      </Text>

      <div className="rejected-divider" />

      <Text className="rejected-label">Reason for Rejection</Text>
      <Text className="rejected-reason">
        Debt-to-income ratio exceeds acceptable threshold
      </Text>
    </Card>
  );
};

export default ApplicationRejectedAlert;
